// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GetEnrollmentDetailsRequestModel {
    static getAttributeTypeMap() {
        return GetEnrollmentDetailsRequestModel.attributeTypeMap;
    }
}
GetEnrollmentDetailsRequestModel.discriminator = undefined;
GetEnrollmentDetailsRequestModel.additionalProperties = false;
GetEnrollmentDetailsRequestModel.attributeTypeMap = [
    {
        "name": "programId",
        "baseName": "programId",
        "type": "number"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "dateOfBirth",
        "baseName": "dateOfBirth",
        "type": "Date"
    },
    {
        "name": "city",
        "baseName": "city",
        "type": "string"
    },
    {
        "name": "state",
        "baseName": "state",
        "type": "string"
    },
    {
        "name": "zip",
        "baseName": "zip",
        "type": "string"
    },
];
//# sourceMappingURL=getEnrollmentDetailsRequestModel.js.map